import React, { useEffect, useState, useRef } from 'react';
import {
  Grid,
  Backdrop,
  CircularProgress,
  Tooltip,
  IconButton,
  List,
  ListItem,
  Card,
  Alert
} from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { makeStyles } from '@material-ui/styles';
import html2canvas from 'html2canvas';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import beratSvg from 'src/assets/images/img/Berat.png';
import ArcelikImg from 'src/assets/images/img/1.png';
import BekoImg from 'src/assets/images/img/2.png';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const BeratSvgCard = ({ ServiceShopId, ServiceShopName }) => {
  const classes = useStyles();
  const svgRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [beratYili, setBeratYili] = useState(null);
  const [beratHistory, setBeratHistory] = useState([]);

  const textStyle1 = {
    fontSize: '70px',
    fontFamily: 'Poppins-Regular_2h',
    fill: '#B27409',
  };

  const textStyle2 = {
    fontSize: '27px',
    fontFamily: 'Poppins-Regular_2h',
    fill: 'rgba(0, 0, 0, 0.8)',
  };

  const textStyle3 = {
    fontSize: '31px',
    fontFamily: 'Poppins-Regular_2h',
    fill: 'rgba(178, 116, 9, 0.8)',
  };

  const containerStyle = {
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: 'white',
    width: '1286px',
    height: '909px',
  };

 useEffect(() => {
  if (!ServiceShopId) return;

  setLoading(true);

  axios.get(`GetYSBeratHistory?BirimKodu=${ServiceShopId}`)
    .then((response) => {
      let parsed = [];

      try {
        // Eğer response.data zaten obje ise parse etme
        parsed = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      } catch (error) {
        console.error('JSON parse hatası:', error);
        parsed = [];
      }

      if (Array.isArray(parsed) && parsed.length > 0) {
        setBeratHistory(parsed);

        const latest = parsed.reduce((max, curr) =>
          curr.BeratYil > max.BeratYil ? curr : max,
          parsed[0]
        );

        setBeratYili(latest.BeratYil);
      } else {
        setBeratHistory([]);
        setBeratYili(null);
      }
    })
    .catch((err) => {
      console.error('Berat bilgisi alınamadı:', err);
      setBeratHistory([]);
      setBeratYili(null);
    })
    .finally(() => {
      setLoading(false);
    });
}, [ServiceShopId]);


  const handleDownloadImage = () => {
    const svgElement = svgRef.current;
    const images = svgElement.getElementsByTagName('image');
    const imagePromises = [];

    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      const imageUrl = image.getAttribute('href');
      const promise = new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          image.setAttribute('href', canvas.toDataURL());
          resolve();
        };
        img.src = imageUrl;
      });
      imagePromises.push(promise);
    }

    Promise.all(imagePromises).then(() => {
      html2canvas(svgElement, { background: '#FFFFFF' }).then((canvas) => {
        const link = document.createElement('a');
        link.download = `${ServiceShopName}.png`;
        link.href = canvas.toDataURL();
        link.click();
      });
    });
  };

  const formattedShopName = ServiceShopName.split(' ').pop().charAt(0).toLocaleUpperCase('tr-TR') +
    ServiceShopName.split(' ').pop().slice(1).toLocaleLowerCase('tr-TR');

  if (!beratYili && !loading) {
    return <Alert severity="warning">Bu servis için tanımlı bir berat kaydı bulunamadı.</Alert>;
  }

  return (
    <div>
      {loading && (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {!loading && (
        <Grid container spacing={3}>
          <Grid item xs={12} container justifyContent="flex-end">
            <Tooltip title="İndir">
              <IconButton size="large" color="primary" onClick={handleDownloadImage}>
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          {/* Berat Geçmişi Listesi */}
          {beratHistory.length > 0 && (
            <Grid item xs={12}>
              <Card>
                <List>
                  {beratHistory.map((row) => (
                    <ListItem key={row.BeratYil}>
                      <WorkspacePremiumIcon color="primary" />
                      &nbsp;
                      <b>{row.BeratYil} Yıl Beratı</b>
                      &nbsp;
                      {`(Verildiği Yıl: ${row.BeratHakEdisYil})`}
                    </ListItem>
                  ))}
                </List>
              </Card>
            </Grid>
          )}

          {/* SVG Sertifika */}
          {beratYili && (
            <Grid item xs={12}>
              <div style={{ margin: 0 }}>
                <div id="p1" ref={svgRef} style={containerStyle}>
                  <svg width="1286" height="909" xmlns="http://www.w3.org/2000/svg">
                    <image href={beratSvg} width="1286" height="909" />
                    <text x="650" y="210" style={textStyle1} textAnchor="middle">
                      {formattedShopName}
                    </text>
                    <text x="650" y="290" style={textStyle1} textAnchor="middle">
                      Yetkili Servisi
                    </text>
                    <text x="310" y="420" style={textStyle2}>
                      Yetkili servisimiz olarak {beratYili} yıl kalitenin, hizmetin ve başarının
                    </text>
                    <text x="300" y="450" style={textStyle2}>
                      saygın bir temsilcisi oldunuz. Bu özverili çalışmalarınız için takdir
                    </text>
                    <text x="300" y="480" style={textStyle2}>
                      ve teşekkürlerimizi sunarız.
                    </text>
                    <text x="300" y="540" style={textStyle2}>
                      Saygılarımızla,
                    </text>
                    <text x="500" y="660" style={textStyle3}>
                      Arçelik Pazarlama A.Ş.
                    </text>
                    <text x="440" y="690" style={textStyle3}>
                      Müşteri Hizmetleri Direktörlüğü
                    </text>
                    <image href={ArcelikImg} x="420" y="740" />
                    <image href={BekoImg} x="760" y="740" />
                  </svg>
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  );
};

export default BeratSvgCard;
